import { ProgramBookDownloadActions } from '../constants';
import { QueryParams } from 'src/types/grid';
import { ProgramBookDownloadFormData } from 'src/screens/General/screens/ProgramBook/screens/ProgramBookGraph/ProgramBookGraphScreen';
import { Dispatch } from 'redux';
import { SagaPromise } from './auth-actions';

export interface GetProgramBookDownloadsAction {
    type: typeof ProgramBookDownloadActions.FETCH_PROGRAM_BOOK_DOWNLOADS;
    payload: QueryParams;
    all?: any;
}

export function getProgramBookDownloads(params: QueryParams): GetProgramBookDownloadsAction {
    return {
        type: ProgramBookDownloadActions.FETCH_PROGRAM_BOOK_DOWNLOADS,
        payload: params,
    };
}
interface QueryParamsAll extends QueryParams {
    all?: any;
}

export interface GetProgramBookDownloadAction {
    type: typeof ProgramBookDownloadActions.FETCH_PROGRAM_BOOK_DOWNLOAD;
    payload: {
        id: string | number;
    };
}

export function getProgramBookDownload(id: string | number): GetProgramBookDownloadAction {
    return {
        type: ProgramBookDownloadActions.FETCH_PROGRAM_BOOK_DOWNLOAD,
        payload: { id },
    };
}

export interface DeleteProgramBookDownloadAction {
    type: typeof ProgramBookDownloadActions.DELETE_PROGRAM_BOOK_DOWNLOAD;
    payload: {
        id: number | string;
        onSuccess?: () => void;
        onError?: (error: string) => void;
    };
}

export function deleteProgramBookDownload(
    id: number | string,
    onSuccess?: () => void,
    onError?: (error: string) => void,
): DeleteProgramBookDownloadAction {
    return {
        type: ProgramBookDownloadActions.DELETE_PROGRAM_BOOK_DOWNLOAD,
        payload: { id, onSuccess, onError },
    };
}

export interface PersistProgramBookDownloadAction {
    type: typeof ProgramBookDownloadActions.PERSIST_PROGRAM_BOOK_DOWNLOAD;
    payload: {
        data: ProgramBookDownloadFormData;
        callbacks: SagaPromise<any>;
    };
}

export function persistProgramBookDownload(
    data: ProgramBookDownloadFormData,
    callbacks: SagaPromise<any>,
): PersistProgramBookDownloadAction {
    return {
        type: ProgramBookDownloadActions.PERSIST_PROGRAM_BOOK_DOWNLOAD,
        payload: {
            data,
            callbacks,
        },
    };
}

export const asyncPersistProgramBookDownload = (data: ProgramBookDownloadFormData, dispatch: Dispatch) => {
    return new Promise((resolve, reject) => {
        dispatch(persistProgramBookDownload(data, { resolve, reject }));
    });
};

export type Actions =
    | GetProgramBookDownloadsAction
    | GetProgramBookDownloadAction
    | DeleteProgramBookDownloadAction
    | PersistProgramBookDownloadAction;
